<div class="ui-accordion-header ui-state-default ui-corner-all">
  <a href="#" class="accordition-header-empty-box" (click)="onClick($event)">
    <div class="title"><i class="fa fa-fw" [ngClass]="icon"></i> {{ title }} </div>
    <div class="actions-box"><i class="fa fa-fw" [ngClass]="actionIcon"></i></div>
  </a>
</div>
